<template>
  <div class="howto">
    <h2>ロックタイマー機能</h2>
    <h4>[Space]/[Enter]/タップ・クリック（ヘッダ以外）</h4>
    <p class="h4-level">
      上で設定したしきい値以下の間隔で3連打したとき：全タイマーリセット
    </p>
    <p class="h4-level">
      GO状態のとき：30秒タイマースタート、黄色へ
    </p>
    <p class="h4-level">
      黄色のとき：赤へ
    </p>
    <p class="h4-level">
      赤のとき：ロック状態へ、5分タイマースタート（スタートしていなければ）
    </p>
    <p class="h4-level">
      ロック状態：赤へ戻る（30秒タイマー開始から30秒経っていないときのみ/5分タイマーはリセットされない）
    </p>
    <h4>[Delete]/[Esc]/[Backspace]/[F5]/ページ更新</h4>
    <p class="h4-level">
      ロックタイマーリセット
    </p>
    <h2>周回ストップウォッチ機能</h2>
    <h4>[r]/START/RUNNINGボタン</h4>
    <p class="h4-level">
      周回ストップウォッチスタート<br>
      既にスタートしていた場合はタイムを記録して新規の周回を開始
    </p>
    <h4>[s]/マグカップアイコンボタン</h4>
    <p class="h4-level">
      周回ストップウォッチストップ＆記録
    </p>
    <p class="h2-level">
      ※設定値およびラップタイムはブラウザのlocalstorageへ保存します。
    </p>
  </div>
</template>

<script>
  export default {
    name: 'HowTo',
    props: [],
    data: function(){
      return {
      }
    },
    mounted: function() {},
    methods: {}
  }
</script>

<style>
.howto {
  text-align: left;
  width: calc(94vw - 40px);
  padding: 20px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: rgba(255,255,255,0.9);
  overflow: hidden;
  border:1px solid black;
}
.howto-text {
  margin: 1em;
  overflow: hidden;
}
h2 {
  margin-top: 0.3em;
  margin-bottom: 0.3em;
}
h3 {
  margin-left: 0.2em;
  margin-top: 0.2em;
  margin-bottom: 0.2em;
}
h4 {
  margin-left: 0.5em;
  margin-top: 0.3em;
  margin-bottom: 0.1em;
}
p.h4-level {
  margin-left: 0.5em;
  margin-top: 0.1em;
  margin-bottom: 0.1em;
  font-size: 0.8em;
}
p.h2-level {
  margin-top: 1em;
  margin-bottom: 0.1em;
  font-size: 0.8em;
}

</style>